/**
 * Created by ah on 26/04/17.
 */
export const UIConstants = {
    RT_OVW_COMPACT: 'compact',
    RT_OVW_IMAGE: 'image',
    RT_OVW_FULL: 'full',
    LOOKLET_COLOR_1:'#13C39D'
}


// WEBPACK FOOTER //
// ./src/model/constants/uiConstants.js